export enum TransferType {
  MoveIn = 1,
  MoveOut = 2,
  Reallocation = 3,
  Shipment = 4,
  Transfer = 5,
}

export enum TransferDirection {
  In = 1,
  Out = 2,
}

export interface Transfer {
  id: string;
  unitId: string;
  quantity: number;
  direction: TransferDirection;
  sourceType: number | null;
  sourceId: string | null;
  destinationType: number | null;
  destinationId: string | null;
  boxRefNumber: string | null;
  itemName: string | null;
  unitBarcode: string | null;
  sourceName: string | null;
  destinationName: string | null;
}

export interface Operation {
  id: string;
  type: TransferType;
  name: string | null;
  refNumber: string | null;
  timestamp: string;
  userId: string;
  userName: string;
  notes: string;
  referenceId: string;
  transfers: Transfer[];
}

export interface OperationListResponse {
  items: Operation[];
  itemsDictionary: any;
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

export interface OperationDetailResponse extends Operation {}